import { post } from '../utils/api';

export const useSubmitContact = () => (form) => post('/contact', form);
